module.exports = __webpack_public_path__ + "img/1585858995.63c90ccb.jpg";